import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 16.5C12.3125 16.5 14.4375 15.2812 15.625 13.25C16.7813 11.25 16.7812 8.78125 15.625 6.75C14.4375 4.75 12.3125 3.5 10 3.5C7.65625 3.5 5.53125 4.75 4.34375 6.75C3.1875 8.78125 3.1875 11.25 4.34375 13.25C5.53125 15.2812 7.65625 16.5 10 16.5ZM10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9063 14C15.4688 16.5 12.8438 18 10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2ZM10 13.5C9.78125 13.5 9.5625 13.4375 9.4375 13.2812L6.1875 9.78125C5.96875 9.5625 5.9375 9.25 6.0625 8.96875C6.15625 8.6875 6.4375 8.5 6.75 8.5H13.25C13.5313 8.5 13.8125 8.6875 13.9375 8.96875C14.0313 9.25 14 9.5625 13.7813 9.78125L10.5313 13.2812C10.4063 13.4375 10.1875 13.5 10 13.5Z"
	})
});
const ForwardRef = forwardRef(SvgDropdown);
export default ForwardRef;
